import { render } from "./BuyModal.vue?vue&type=template&id=3d901d10"
import script from "./BuyModal.vue?vue&type=script&lang=js"
export * from "./BuyModal.vue?vue&type=script&lang=js"

import "./BuyModal.vue?vue&type=style&index=0&id=3d901d10&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__